import HeaderStyles from "../../../components/Header/HeaderStyles";

export const AlertsStyles = {
  heading: {
    color: "#383D4E",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    fontFamily: "Playfair Display",
  },
  payNowHeadingStyle: {
    fontFamily: "Playfair Display",
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "22px",
    textAlign: "left",
  },
  HeaderStyles: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #D8D8D8",
    width: "100%",
    padding: "20px",
  },
  paymentCardStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    // height: "100%",
  },
  paperPropStyles: {
    overflow: "unset",
    width: "50%",
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  AlertCardStyles: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "0px 30px 30px 30px",
  },
};
